import React from "react";
import { AppBar, Button, Toolbar } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    top: "auto",
    height: 64,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    paddingLeft: 118,
    paddingRight: 79,
    // ensure footer z-index is lower than the AppBar (so it doesn't cover header)
    zIndex:
      theme && theme.zIndex && typeof theme.zIndex.appBar !== "undefined"
        ? Math.max(0, theme.zIndex.appBar - 10)
        : 1000,
    marginTop: "auto", /* Push footer to bottom */
    backgroundColor: theme?.palette?.primary?.main || "#3F51B5", // Updated to match logo color
    "@media (max-width: 900px)": {
      paddingLeft: 10,
      paddingRight: 10,
      height: 72,
    },
  },
  menuButton: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    fontSize: "18px",
    marginLeft: 38,
    "@media (max-width: 900px)": {
      marginLeft: 10,
      marginBottom: 10,
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: 0,
    "@media (max-width: 900px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },
}));

const footerData = [
  { label: "Contact Us", href: "" },
  { label: "Report an issue", href: "" },
];

export default function Footer() {
  const classes = useStyles();

  const getMenuButtons = () =>
    footerData.map(({ label }) =>
      label === "Contact Us" || label === "Report an issue" ? (
        <Button
          key={label}
          href={`mailto:${process.env.REACT_APP_CONTACTUS_EMAIL}`}
          style={{ color: "white" }}
          className={classes.menuButton}
        >
          {label}
        </Button>
      ) : null
    );

  return (
    <footer>
      <AppBar position="fixed" className={classes.footer} elevation={2}>
        <Toolbar className={classes.toolbar}>{getMenuButtons()}</Toolbar>
      </AppBar>
    </footer>
  );
}
